import { Routes } from '@angular/router';
import { AuthLayout } from './layout/auth-layout/auth-layout';
import { MainLayout } from './layout/main-layout/main-layout';
import { accountSelectionGuard, authGuard, guestGuard } from './core/guards';
import { configResolver } from './core/resolvers';

export const routes: Routes = [
  // Public marketing landing (no guard, no shell) — partners.gozem.co homepage.
  // Authenticated users can view it too; the header CTA adapts to auth state.
  {
    path: '',
    pathMatch: 'full',
    data: { crossfade: true },
    loadComponent: () => import('./features/landing/landing').then((m) => m.Landing),
  },

  // Auth Routes (without MainLayout)
  {
    path: 'login',
    component: AuthLayout,
    canActivate: [guestGuard],
    data: { crossfade: true },
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'forgot-password',
    component: AuthLayout,
    canActivate: [guestGuard],
    data: { crossfade: true },
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.FORGOT_PASSWORD_ROUTES),
  },
  // Reachable both WITH a session (single merchant, confirmation mode) and WITHOUT one
  // (several merchants, selection mode — the backend issues no token until one is chosen).
  // `authGuard` would reject the second case; see accountSelectionGuard.
  {
    path: 'select-account',
    component: AuthLayout,
    canActivate: [accountSelectionGuard],
    data: { crossfade: true },
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.SELECT_ACCOUNT_ROUTES),
  },

  // Authenticated Routes (with MainLayout)
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    // load runtime config once the user is authenticated (Bearer
    // attached by the interceptor). Never blocks navigation on failure.
    resolve: { config: configResolver },
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: 'transactions',
        loadChildren: () =>
          import('./features/transactions/transactions.routes').then((m) => m.TRANSACTION_ROUTES),
      },
      {
        path: 'wallet',
        loadChildren: () => import('./features/wallet/wallet.routes').then((m) => m.WALLET_ROUTES),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
      },
      { path: '', redirectTo: '/wallet', pathMatch: 'full' },
    ],
  },

  // Fallback
  { path: '**', redirectTo: '/wallet' },
];
